// removed by extract-text-webpack-plugin
module.exports = {"root":"IconCheckmark__root__2H9Ig"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconCheckmark/IconCheckmark.css
// module id = 1833
// module chunks = 0